import React from 'react';
import './tailors.css';

import jamesImage from '../../../../assets/img/tailors/james.png';
import sarahImage from '../../../../assets/img/tailors/sarah.png';
import davidImage from '../../../../assets/img/tailors/david.png';
import amiraImage from '../../../../assets/img/tailors/amira.png';
import thaboImage from '../../../../assets/img/tailors/thabo.png';
import lindaImage from '../../../../assets/img/tailors/download.jpeg';

const Tailors = () => {
  const tailors = [
    {
      name: "James Moloi",
      specialty: "Master Bespoke Tailor",
      experience: "15 Years",
      description: "Leads our bespoke division with precision craftsmanship and European training.",
      image: jamesImage,
    },
    {
      name: "Sarah Chen",
      specialty: "Creative Design Director", 
      experience: "12 Years",
      description: "Brings artistic vision to custom design projects with contemporary aesthetics.",
      image: sarahImage,
    },
    {
      name: "David Mbatha",
      specialty: "Alterations Specialist",
      experience: "8 Years", 
      description: "Transforms garments with surgical precision and deep construction understanding.",
      image: davidImage,
    },
    {
      name: "Amira Hassan",
      specialty: "Styling Consultant",
      experience: "10 Years",
      description: "Develops complete wardrobe solutions focusing on personal style and comfort.",
      image: amiraImage,
    },
    {
      name: "Thabo Nkosi", 
      specialty: "Digital Pattern Engineer",
      experience: "6 Years",
      description: "Bridges traditional tailoring with digital innovation and 3D pattern design.",
      image: thaboImage,
    },
    {
      name: "Linda van der Merwe",
      specialty: "Textile Innovation Expert", 
      experience: "9 Years",
      description: "Pioneers sustainable fabric solutions and smart textiles for quality garments.",
      image: lindaImage,
    }
  ];

  return (
    <div className="tailors">
      <div className="bg__grid"></div>
      
      <div className="tailors__container">
        <nav className="holographic__nav">
          <a href='/tailor' className="nav__item">About</a>
          <a href='/tailorprofiles' className="nav__item nav__item--active">Tailors</a>
          <a href='/tailorservices' className="nav__item">Services</a>
        </nav>

        <main>
          <section className="title__section">
            <h2 className="content__title">Our Master Tailors</h2>
            <p className="content__subtitle">Expert Craftsmanship</p>
          </section>

          <div className="tailors__grid">
            {tailors.map((tailor, index) => (
              <div key={index} className="tailor__card">
                <div className="tailor__image__container">
                  <img src={tailor.image} alt={tailor.name} className="tailor__image" />
                </div>
                
                <div className="tailor__content">
                  <h3>{tailor.name}</h3>
                  <p className="tailor__specialty">{tailor.specialty}</p>
                  <p className="tailor__description">{tailor.description}</p>
                  <div className="experience__badge">{tailor.experience}</div>
                </div>
              </div>
            ))}
          </div>

          <div className="collective__stats">
            <h3>Our Collective Excellence</h3>
            <div className="stats__grid">
              <div className="stat__item">
                <div className="stat__number">60+</div>
                <div className="stat__label">Years Experience</div>
              </div>
              <div className="stat__item">
                <div className="stat__number">6000+</div>
                <div className="stat__label">Garments Crafted</div>
              </div>
              <div className="stat__item">
                <div className="stat__number">96%</div>
                <div className="stat__label">Client Satisfaction</div>
              </div>
              <div className="stat__item">
                <div className="stat__number">200+</div>
                <div className="stat__label">Custom Designs</div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default Tailors;